var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1 4.8125C1 3.93886 1 3.50204 1.14273 3.15747C1.33303 2.69804 1.69804 2.33303 2.15747 2.14273C2.50204 2 2.93886 2 3.8125 2H11.1875C12.0611 2 12.498 2 12.8425 2.14273C13.302 2.33303 13.667 2.69804 13.8573 3.15747C14 3.50204 14 3.93886 14 4.8125M4.6875 17H10.3125M7.5 2V17M19 1.9998L21 1V9.00036",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperscript);
export default __webpack_public_path__ + "static/media/superscript.c33dfcd4078265c897648363e644f765.svg";
export { ForwardRef as ReactComponent };